module.exports = __webpack_public_path__ + "static/media/sportfitness.fee8d464.png";